<template>
  <section class="dash-section" aria-labelledby="dash-finance-heading">
    <div class="dash-section__head">
      <div>
        <h2 id="dash-finance-heading" class="dash-section__title">Financial Overview</h2>
        <p class="dash-section__subtitle">Credits, usage, and cost intelligence</p>
      </div>
    </div>

    <div class="dash-finance-grid" role="list">
      <article
        v-for="item in metrics"
        :key="item.key"
        class="dash-finance-card"
        :class="{ 'dash-finance-card--large': item.large }"
        role="listitem"
      >
        <span class="dash-finance-card__label">{{ item.label }}</span>
        <span class="dash-finance-card__value">{{ item.value }}</span>
        <span class="dash-finance-card__sub">{{ item.sub }}</span>
      </article>
    </div>
  </section>
</template>

<script setup>
defineOptions({ name: 'DashboardFinancialPanel' })

defineProps({
  metrics: { type: Array, default: () => [] },
})
</script>
